import script from './component-lib.esm3.js';
import normalizeComponent from '../../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isWidget ? _c('div', {
    ref: "formRef",
    staticClass: "typeform-container",
    style: _vm.styles
  }) : _c('ProfileBtn', _vm._b({
    attrs: {
      "component": "button",
      "label": _vm.formOptions.button_text
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'ProfileBtn', _vm.btnProps, false));
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-5767a8af_0", {
    source: ".typeform-container[data-v-5767a8af]{background:var(--c-bg-color);border:var(--p-btn-border-width) solid var(--p-btn-border-color);border-width:min(var(--p-btn-border-width),5px);border-radius:var(--p-btn-border-radius);border-radius:min(var(--p-btn-border-radius),10px);overflow:hidden;width:100%}.typeform-container[data-v-5767a8af] *{border-radius:min(var(--p-btn-border-radius),10px);height:100%;width:100%}",
    map: undefined,
    media: undefined
  }), inject("data-v-5767a8af_1", {
    source: ".v-form--remove-bg .typeform-container{background:0 0;border:none;border-radius:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-5767a8af";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Typeform = __vue_component__;
export { Typeform as default };